const lookupsRequests={
    list: {
        providerFilterPlaceHolder: 'مقدم الخدمة' ,
        noData:'لا يوجد طلبات عمليات حتى الآن',
        bulkSelection:'تحديد متعدّد',
        itemsSelected:' العناصر المختارة',
        addedByProvider:'أُضيف بواسطة المزوّد',
        serviceTypeFilterPlaceHolder: 'تصنيف الخدمة',
        multiSessions: 'جلسات متعددة',
        singleService: 'خدمة فردية'
    },
    card: {
        acceptLabel: 'أوافق',
        rejectLabel:'أرفض',
        multiSessionsTag: 'جلسات متعددة'
    },
    rejectModal: {
        singleTitle:"رفض طلب العمليات",
        bulkTitle:'رفض طلبات العمليات',
        contentText:'سبب الرفض',
        placeholder:'ادخل سبب الرفض',
    }
};

export default lookupsRequests;